/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Review_Hold_DescriptionInputs */

const en_orders_review_hold_description = /** @type {(inputs: Orders_Review_Hold_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The order should stay on hold.`)
};

const es_orders_review_hold_description = /** @type {(inputs: Orders_Review_Hold_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El pedido debe mantenerse en espera.`)
};

/**
* | output |
* | --- |
* | "The order should stay on hold." |
*
* @param {Orders_Review_Hold_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_review_hold_description = /** @type {((inputs?: Orders_Review_Hold_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Review_Hold_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_review_hold_description(inputs)
	return es_orders_review_hold_description(inputs)
});